<template>
      <div no-body class="lku-customer"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col cols="10">
          <b-input-group>
              <b-input-group-prepend><span class="p-2">Filter</span></b-input-group-prepend>
              <b-form-input v-model="tblData.CustName" placeholder="Name" @keyup.13.native="refresh()"></b-form-input>
              <b-form-input v-model="tblData.npwp" placeholder="NPWP" @keyup.13.native="refresh()" class="ml-1"></b-form-input>
              <b-form-input v-model="tblData.CustCode" placeholder="CustCode" @keyup.13.native="refresh()" class="ml-1"></b-form-input>
              <b-input-group-append>
                    <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
              </b-input-group-append>
              <b-input-group-append>
                    <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
              </b-input-group-append>
          </b-input-group>
          </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblCust" style="font-size:smaller;" 
          responsive small striped hover
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(Address1)="data">
          {{ data.item.Address1 }}
          {{ data.item.Address2 }}
        </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-customer {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import customer from "../../apis/customer";

export default {
  data() {
    return {
      fields: [
          { key: "CustCode" , 
            label: "Customer Code",
            sortable: true
          },
          { key: "CustName" , 
            label: "Customer Name",
            sortable: true
          },
          {
            key: "Address1",
            label: "Billing Address",
          },
          {
            key: "City",
            label: "City",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'CustName',
        sortDesc: false, advertiser:1
      },
      lkuLoading:false
    };
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await customer.list(this.tblData);      
      this.lkuLoading=false;
      return list;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData={CustName:'', CustCode: ''};
        this.refresh();
    },    
    keymonitor: function(event) {
        console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblCust.refresh();
       }
    },   
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },     
    refresh() {
      this.$refs.tblCust.refresh();
    }
  }
};
</script>
